import { CalciteInputDatePicker } from '@esri/calcite-components-react';

import { undefBool } from '../../../util/webComponentUtils';
import { formatEsriDate, parseEsriDate } from '../../../util/dateUtils';
import { useEditorFocus } from './useEditorFocus';

export const DateCellEditor: CellEditor = ({
  value,
  onChange,
  disabled,
  readOnly,
  autoEdit,
}) => {
  const ref = useEditorFocus<HTMLCalciteInputDatePickerElement>((el) => {
    el.setFocus();
    el.setAttribute('open', 'true');
  }, autoEdit);

  return (
    <CalciteInputDatePicker
      className="h-9 pl-[1px] top-[1px]"
      onCalciteInputDatePickerChange={(e) => {
        const newValue = e.target.valueAsDate;
        if (newValue instanceof Date) {
          onChange(formatEsriDate(newValue));
        }
      }}
      valueAsDate={parseEsriDate(value)}
      overlayPositioning="fixed"
      disabled={undefBool(disabled)}
      placeholder="YYYY-MM-DD"
      readOnly={undefBool(readOnly)}
      ref={ref}
    />
  );
};
